export const transformMenuTypes = (menuType: string, recipeId: string) => ({
  Id: recipeId + menuType,
  Title: menuType,
});
